import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Base URL
const BASE_URL =  process.env.REACT_APP_API_URL;

// Async thunk for fetching all permissions
export const fetchAllPermissions = createAsyncThunk(
  "permissions/fetchAllPermissions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/Permissions/`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "فشل في جلب الصلاحيات"
      );
    }
  }
);

// Async thunk for fetching employee permissions
export const fetchEmployeePermissions = createAsyncThunk(
  "permissions/fetchEmployeePermissions",
  async (employeeId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/Permissions/Employee/${employeeId}/`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "فشل في جلب صلاحيات الموظف"
      );
    }
  }
);

// Async thunk for updating employee permissions
export const updateEmployeePermissions = createAsyncThunk(
  "permissions/updateEmployeePermissions",
  async ({ employeeId, permissions }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/Permissions/Employee/${employeeId}/`,
        { permissions },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "فشل في تحديث الصلاحيات"
      );
    }
  }
);

const permissionsSlice = createSlice({
  name: "permissions",
  initialState: {
    allPermissions: {},
    employeePermissions: [],
    currentEmployee: null,
    loading: false,
    updateLoading: false,
    error: null,
    updateSuccess: false,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearUpdateSuccess: (state) => {
      state.updateSuccess = false;
    },
    clearEmployeePermissions: (state) => {
      state.employeePermissions = [];
      state.currentEmployee = null;
    },
  },
  extraReducers: (builder) => {
    // Fetch all permissions
    builder
      .addCase(fetchAllPermissions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllPermissions.fulfilled, (state, action) => {
        state.loading = false;
        state.allPermissions = action.payload.permissions;
      })
      .addCase(fetchAllPermissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch employee permissions
      .addCase(fetchEmployeePermissions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmployeePermissions.fulfilled, (state, action) => {
        state.loading = false;
        state.employeePermissions = action.payload.permissions;
        state.currentEmployee = action.payload.employee;
      })
      .addCase(fetchEmployeePermissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update employee permissions
      .addCase(updateEmployeePermissions.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updateEmployeePermissions.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.updateSuccess = true;
        // Update the permissions in the state
        if (action.payload.permissions) {
          state.employeePermissions = action.payload.permissions;
        }
      })
      .addCase(updateEmployeePermissions.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearUpdateSuccess, clearEmployeePermissions } = permissionsSlice.actions;
export default permissionsSlice.reducer;